module.exports = __webpack_public_path__ + "static/media/final-scene-all-of-them-are-at-home.eb115b06.png";